import { RouteRecordRaw } from "vue-router"

import bgImage from "@/assets/images/merchant/merchant-intro-bg.jpg"

export const PreApplyRoutes: RouteRecordRaw[] = [
  {
    path: "/pre-apply",
    meta: {
      layout: "responsiveBgImage",
      imgSrc: bgImage,
      hideStepper: true,
    },
    children: [
      {
        path: "start",
        component: () => import("@/views/preapply/PreApplyStartView.vue"),
        meta: {
          preventBack: true,
        },
      },
      {
        path: ":state/disclosures",
        redirect: "finish",
      },
      {
        path: "IL/disclosures",
        strict: false,
        component: () => import("@/views/preapply/PreApplyIDFPRView.vue"),
      },
      {
        path: "finish",
        component: () => import("@/views/preapply/PreApplyFinishView.vue"),
        meta: {
          preventBack: true,
        },
      },
    ],
  },
]

export default PreApplyRoutes
